import { t } from 'i18next';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';

interface DiscardUnsavedChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DiscardUnsavedChangesDialog({
  isOpen,
  onClose,
  onConfirm,
}: DiscardUnsavedChangesDialogProps) {
  return (
    <ConfirmationDialog
      confirmButtonProps={{ children: t('actions.discard') }}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t(
        'administration.integration.rutter.quick_books_online.item_rules.discard.title',
      )}
    >
      {t('administration.integration.rutter.quick_books_online.item_rules.discard.body')}
    </ConfirmationDialog>
  );
}
